import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { SegmentsForEdit, TimeSlotFormContext } from '../wizard/time-slot.types';
import { isOverlappingSegment } from '../utils/is-overlapping-segment';

export const useAvailabilityEditWarnings = ({
  differentDayAvailabilities,
}: {
  differentDayAvailabilities: SegmentsForEdit[];
}) => {
  const { watch, formState } = useFormContext<TimeSlotFormContext>();
  const { t } = useTranslation('all-platforms-common');

  const selectedAvailability = watch('availability');
  const selectedAvailabilityErrors = formState.errors.availability;
  const selectedWorker = watch('workerSelect');
  const selectedWorkerError = formState.errors.workerSelect;
  const workerOptions = watch('workerOptions');
  const workerOptionsError = formState.errors.workerOptions;

  const availabilityHeaderWarning: string | undefined = useMemo(() => {
    const overlappingIndex = selectedAvailability.findIndex((segment) =>
      isOverlappingSegment(segment, [...selectedAvailability, ...differentDayAvailabilities])
    );
    if (overlappingIndex !== -1) {
      return t('edit_availability.availability_header_error_timeslot_overlap');
    }
    if (selectedAvailability.length < 1 || selectedAvailabilityErrors) {
      return t('edit_availability.availability_header_error_message');
    }

    return undefined;
  }, [selectedAvailability.length, selectedAvailabilityErrors]);

  const workerSectionHeaderError: string | undefined = useMemo(() => {
    if (!selectedWorker || selectedWorkerError) {
      return t('edit_availability.worker_header_error_message');
    }

    return undefined;
  }, [selectedWorker, selectedWorkerError, workerOptions.length, workerOptionsError]);

  return {
    availabilityHeaderWarning,
    workerSectionHeaderError,
  };
};
